import { call, put, takeLeading } from 'redux-saga/effects'
import * as fromActions from '../../actions/chat.action'
import I18n from 'i18n'
import { ErrorToast } from 'components/ui/toast/toastsTemplates'
import { getConversationMessages } from 'api/chat/Get'

async function handleGetMessages({ conversationId, identifier }: any) {
  return await getConversationMessages(conversationId, identifier)
}

function* getConversationMessagesEffectSaga(action: any) {
  try {
    const data = yield call(handleGetMessages, action.payload)
    yield put(fromActions.Actions.getChatMessagesSuccess(data))
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.genericError'))
    console.log('error: ', error)
  }
}

export function* getConversationMessagesWatcherSaga() {
  yield takeLeading(fromActions.GET_CHAT_CONVERSATION_MESSAGES, getConversationMessagesEffectSaga)
}
